import HeroBannerConnector from './HeroBannerConnector';

export default HeroBannerConnector;
